import { render } from "./DropInfo.vue?vue&type=template&id=31210cd8&scoped=true"
import script from "./DropInfo.vue?vue&type=script&lang=js"
export * from "./DropInfo.vue?vue&type=script&lang=js"

import "./DropInfo.vue?vue&type=style&index=0&id=31210cd8&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-31210cd8"

export default script